type ClearFilterButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

/**
 * ClearFilterButton component - "Clear All" button to reset all filters
 *
 * Adapted from operations-iol-webapp for Tailwind CSS styling.
 */
export function ClearFilterButton({ onClick, disabled = false }: ClearFilterButtonProps) {
  return (
    <button
      type="button"
      aria-label="Clear Filters"
      disabled={disabled}
      onClick={onClick}
      className={`
        flex items-center gap-1.5 px-3 py-1.5
        border border-gray-200 dark:border-[#324467] rounded-lg
        text-xs font-bold text-gray-600 dark:text-gray-300
        hover:bg-gray-50 dark:hover:bg-gray-800
        transition-colors duration-150
        disabled:opacity-50 disabled:cursor-not-allowed
      `}
    >
      <span className="material-symbols-outlined text-sm">refresh</span>
      Reset All
    </button>
  );
}
